import { useQuery } from '@tanstack/react-query'
import { tenMinutes } from '~constants/constants'
import { IUserInfoReadResponse } from '~hooks/queries/me/me-types'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export function useGetMe({ isDisabled }: { isDisabled?: boolean } = {}) {
  const fetchRequest = useFetch<IUserInfoReadResponse>()
  return useQuery({
    queryKey: ['/me'],
    queryFn: () => fetchRequest(`${apiBase()}/me`),
    staleTime: tenMinutes,
    enabled: !isDisabled,
  })
}
